var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('training-m',{staticClass:"display-mobile",attrs:{"id":_vm.id}}),_c('training-pc',{staticClass:"display-pc",attrs:{"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }